import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { WorkitemInteractionComponent } from './workitem-interaction.component';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild()
  ],
  declarations: [
    WorkitemInteractionComponent
  ],
  exports: [
    WorkitemInteractionComponent
  ]
})
export class WorkItemInteractionModule {
}
